__webpack_public_path__ = process.env.ASSET_PATH;